module.exports = __webpack_public_path__ + "img/gj2.11e1fc91.jpg";